import React, { type VFC } from 'react';
import { DiscountCardMarchPromo2026 } from 'reactApp/sections/MobileSubscriptionsPage/Discounts/Components/DiscountCardMarchPromo2026/DiscountCardMarchPromo2026';
import { DiscountCardSummerPromo2026 } from 'reactApp/sections/MobileSubscriptionsPage/Discounts/Components/DiscountCardSummerPromo2026/DiscountCardSummerPromo2026';

import { DiscountCard } from '../DiscountCard/DiscountCard';
import { buttonTextMap, DISCOUNTS } from '../DiscountCard/DiscountCard.constant';
import type { Props as DiscountCardProps } from '../DiscountCard/DiscountCard.types';

type Props = {
    data: Array<Omit<DiscountCardProps, 'onClick' | 'buttonText'>>;
    isRebrandingQuotaLanding?: boolean;
};

export const DiscountList: VFC<Props> = ({ data, isRebrandingQuotaLanding }) => {
    return (
        <>
            {data.map(({ type, id, title, text, link, analyticsName, promoConditions }) => {
                if (type === DISCOUNTS.summerPromo2026) {
                    return <DiscountCardSummerPromo2026 key={`${type}-${id}`} />;
                }

                if (type === DISCOUNTS.marchPromo2026) {
                    return <DiscountCardMarchPromo2026 key={`${type}-${id}`} />;
                }

                return (
                    <DiscountCard
                        id={id}
                        key={`${type}-${id}`}
                        type={type}
                        text={text}
                        title={title}
                        buttonText={buttonTextMap[type]}
                        link={link}
                        analyticsName={analyticsName}
                        isRebrandingQuotaLanding={isRebrandingQuotaLanding}
                        promoConditions={promoConditions}
                    />
                );
            })}
        </>
    );
};
